"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.atZones = void 0;
var atZones = exports.atZones = [{
  id: 'VIENNE',
  name: 'Vienne',
  country: 'AT',
  cornerNW: {
    latitude: 48.3223,
    longitude: 16.1826
  },
  cornerSE: {
    latitude: 48.1366,
    longitude: 16.5775
  },
  subZones: [{
    name: 'Vienne Innere Stadt',
    zipcodes: {
      1010: {
        label: '1010'
      }
    }
  }, {
    name: 'Vienne Leopoldstadt',
    zipcodes: {
      1020: {
        label: '1020'
      }
    }
  }, {
    name: 'Vienne Landstraße',
    zipcodes: {
      1030: {
        label: '1030'
      }
    }
  }, {
    name: 'Vienne Wieden',
    zipcodes: {
      1040: {
        label: '1040'
      }
    }
  }, {
    name: 'Vienne Margareten',
    zipcodes: {
      1050: {
        label: '1050'
      }
    }
  }, {
    name: 'Vienne Mariahilf',
    zipcodes: {
      1060: {
        label: '1060'
      }
    }
  }, {
    name: 'Vienne Neubau',
    zipcodes: {
      1070: {
        label: '1070'
      }
    }
  }, {
    name: 'Vienne Josefstadt',
    zipcodes: {
      1080: {
        label: '1080'
      }
    }
  }, {
    name: 'Vienne Alsergrund',
    zipcodes: {
      1090: {
        label: '1090'
      }
    }
  }, {
    name: 'Vienne Simmering',
    zipcodes: {
      1110: {
        label: '1110'
      }
    }
  }]
}];